namespace TabAurous.ECommerce {
    export interface OrderStatus extends Serenity.ServiceRequest {
        orderid?: number;
        status?: string;
        sku?: string;
        qty?: number;
    }
}
